// import '../App.css';
// import owner from '../assets/images/owner.jpeg'

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../App.css";

function Barbers() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("https://family-barbers.com/wp-json/acf/v3/pages/14")
      .then((res) => res.json())
      .then((json) => setData(json.acf))
      .catch((err) => console.error("Error fetching ACF data:", err));
  }, []);

  if (!data) return null;

  return (
    <div id="barbers" className="section">
      <motion.div
        className="barber-parent-container"
        whileInView={{ y: 0, opacity: 1 }} // animate into place when visible
        initial={{ x: -800, opacity: 1 }}       // Start off-screen left
        animate={{ x: 0, opacity: 1 }}          // End in place, fully visible
        transition={{ duration: 0.8, ease: "easeOut" }} // Animation settings
      >
        <h1>{data.barbers_title}</h1>
        <div className="barber-child-container">
          {data.barber_image && (
            <img
              src={data.barber_image.url}
              alt={data.barber_image.alt || data.barber_name}
            />
          )}
          <h2>{data.barber_name}</h2>
        </div>
      </motion.div>
    </div>
  );
}

export default Barbers;

